import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorGroup } from '../dashboard/errors-column.component';

/** Problems only Aivor support can fix: the details to send them, with a copy button. */
@Component({
  selector: 'app-support-fix',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './support-fix.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './fix-section.shared.css'],
})
export class SupportFixComponent {
  @Input({ required: true }) group!: ErrorGroup;

  @ViewChild('details') private details?: ElementRef<HTMLPreElement>;

  copied: 'ok' | 'failed' | null = null;

  get text(): string {
    const lines = [`Problem: ${this.group.label}`];
    for (const r of this.group.records) {
      const code = r.recordId && r.recordId !== r.name ? ` (${r.recordId})` : '';
      lines.push(`${r.name}${code}: ${r.detail}`);
    }
    const more = this.group.count - this.group.records.length;
    if (more > 0) lines.push(`… and ${more} more`);
    return lines.join('\n');
  }

  copy(): void {
    const done = (ok: boolean) => {
      this.copied = ok ? 'ok' : 'failed';
      if (!ok) this.selectDetails();
    };
    try {
      navigator.clipboard.writeText(this.text).then(() => done(true), () => done(false));
    } catch {
      done(false);
    }
  }

  // Some browsers refuse the clipboard; selected text can still be copied by hand.
  private selectDetails(): void {
    const el = this.details?.nativeElement;
    const selection = window.getSelection();
    if (!el || !selection) return;
    const range = document.createRange();
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}
